import { MessageCircle } from "lucide-react";
import { LINKS } from "@/data/content";

export default function WhatsAppFloat() {
  return (
    <a
      href={LINKS.flutuante}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Fale comigo no WhatsApp"
      className="group fixed bottom-6 right-6 z-50 flex items-center"
    >
      <span className="hidden sm:block absolute right-full mr-3 whitespace-nowrap rounded-full bg-[#0B1120] text-white text-xs font-semibold px-4 py-2 opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-[opacity,transform] duration-300 pointer-events-none">
        Fale comigo no WhatsApp
      </span>
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-5px_rgba(37,211,102,0.6)] group-hover:scale-110 transition-transform duration-300">
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
        <MessageCircle size={26} className="relative" />
      </span>
    </a>
  );
}
